const order = {
  namespaced: true,
  state: {
    template: {
      creator: '',
      templateName: '',
      fieldGroups: [],
      type: 0
    },
    order: {},
    orderPermission: {},
    widgetOrderUtils: {
      showOrders: true,
      showTemplates: false,
      showOrderDetail: false
    }
  },
  getters: {},
  mutations: {
    saveTemplate(state, template) {
      state.template = template
    },
    saveOrder(state, order) {
      state.order = order
    },
    saveOrderPermission(state, orderPermission) {
      state.orderPermission = orderPermission
    },
    saveWidgetOrderUtils(state, widgetOrderUtils) {
      state.widgetOrderUtils = widgetOrderUtils
    }
  },
  actions: {
    saveTemplate(context, template) {
      context.commit('saveTemplate', template)
    },
    saveOrder(context, order) {
      context.commit('saveOrder', order)
    },
    saveOrderPermission(context, orderPermission) {
      context.commit('saveOrderPermission', orderPermission)
    },
    saveWidgetOrderUtils(context, widgetOrderUtils) {
      context.commit('saveWidgetOrderUtils', widgetOrderUtils)
    }
  }
}

export default order
